import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faExchangeAlt, faArrowLeft, faCheckCircle, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import Header from '../components/Header';
import TabBar from '../components/TabBar';
import TaxiLoader from '../components/TaxiLoader';
import { isLoggedIn } from '../services/authService';
import { API_ENDPOINTS } from '../services/constants';
import '../styles/PlakaGecislerim.css';

interface PlakaGecis {
  Id: number;
  Plate: string;
  Date: string;
  Machine: string;
  Color?: string;
  tip: 'GIRIS' | 'CIKIS';
}

interface PlakaOzet {
  giris_sayisi: number;
  cikis_sayisi: number;
  toplam_gecis: number;
}

const PlakaGecislerim: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [plakaGecisleri, setPlakaGecisleri] = useState<PlakaGecis[]>([]);
  const [plakaOzet, setPlakaOzet] = useState<PlakaOzet>({ giris_sayisi: 0, cikis_sayisi: 0, toplam_gecis: 0 });
  const [selectedPeriod, setSelectedPeriod] = useState<'gunluk' | 'haftalik' | 'aylik'>('aylik');
  const [userPlaka, setUserPlaka] = useState<string | null>(null);
  const [userGroup, setUserGroup] = useState<string | null>(null);

  useEffect(() => {
    checkAuthAndFetchData();
  }, []);

  const checkAuthAndFetchData = async () => {
    try {
      // Önce userInfo'dan uyeId'yi alalım
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || localStorage.getItem('userInfo') || '{}');
      const uyeId = userInfo.uyeid || localStorage.getItem('uyeid');
      
      console.log('UserInfo:', userInfo);
      console.log('UyeId:', uyeId);
      console.log('isLoggedIn() sonucu:', isLoggedIn());
      
      if (!uyeId) {
        console.warn('UyeId bulunamadı, login sayfasına yönlendiriliyor');
        navigate('/login');
        return;
      }
      
      // isLoggedIn kontrolünü geçici olarak devre dışı bırakalım
      /*
      if (!isLoggedIn()) {
        console.warn('isLoggedIn() false döndü, login sayfasına yönlendiriliyor');
        navigate('/login');
        return;
      }
      */

      // Kullanıcı bilgilerini al
      const response = await fetch(API_ENDPOINTS.WEBSERVICE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ method: 'apibilgileri', uyeid: uyeId })
      });

      // Önce ham yanıtı görelim
      const responseText = await response.text();
      console.log('API Ham Yanıt:', responseText);
      console.log('API Ham Yanıt uzunluğu:', responseText.length);
      
      let data;
      try {
        // Eğer çift JSON varsa, ilkini al
        let jsonText = responseText;
        if (responseText.includes('}{')) {
          jsonText = responseText.split('}{')[0] + '}';
          console.log('Çift JSON tespit edildi, ilki alınıyor:', jsonText);
        }
        
        data = JSON.parse(jsonText);
        console.log('API Parsed Data:', data);
      } catch (parseError) {
        console.error('JSON Parse Hatası:', parseError);
        console.error('Hatalı JSON:', responseText.substring(0, 200) + '...');
        
        // Alternatif: İlk geçerli JSON'u bulmaya çalış
        try {
          const jsonMatch = responseText.match(/\{[^}]*\}/);
          if (jsonMatch) {
            data = JSON.parse(jsonMatch[0]);
            console.log('Alternatif parse başarılı:', data);
          } else {
            throw parseError;
          }
        } catch {
          throw parseError;
        }
      }
      
              // API'den gelen yanıt başarısızsa, sessionStorage'dan kullanıcı bilgilerini al
        if (!data.success) {
          console.warn('API yanıtı başarısız, sessionStorage kullanılıyor:', data.message);
          
          // SessionStorage'dan kullanıcı bilgilerini al
          const kullanici = userInfo;
          setUserGroup(kullanici.grubu || kullanici.GRUBU);
          
          console.log('SessionStorage kullanıcı grubu:', kullanici.grubu || kullanici.GRUBU);
          console.log('SessionStorage kullanıcı bilgileri:', kullanici);
          
          // Debug için geçici olarak devre dışı
          /*
          if ((kullanici.grubu || kullanici.GRUBU) !== 'UYE') {
            console.warn('UYE grubu değil, grup:', kullanici.grubu || kullanici.GRUBU);
            alert(`Bu sayfaya erişim yetkiniz bulunmamaktadır. Mevcut grubunuz: ${kullanici.grubu || kullanici.GRUBU}. Sadece UYE grubu üyeleri plaka geçişlerini görüntüleyebilir.`);
            navigate('/');
            return;
          }
          */

          // Plaka bilgisi varsa geçişleri getir
          const plakaField = kullanici.plaka || kullanici.PLAKA || kullanici.Plaka;
          if (plakaField) {
            setUserPlaka(plakaField);
            await fetchPlakaGecisleri(plakaField, selectedPeriod);
          } else {
            console.warn('Kullanıcının plaka bilgisi bulunamadı');
            setUserPlaka(null);
            setLoading(false);
          }
        } else if (data.success && data.kullanici && data.kullanici.length > 0) {
          const kullanici = data.kullanici[0];
          setUserGroup(kullanici.GRUBU);
          
          console.log('API kullanıcı grubu:', kullanici.GRUBU);
          console.log('API kullanıcı bilgileri:', kullanici);

          const plakaField = kullanici.plaka || kullanici.PLAKA || kullanici.Plaka;
          if (plakaField) {
            setUserPlaka(plakaField);
            await fetchPlakaGecisleri(plakaField, selectedPeriod);
          } else {
            console.warn('API kullanıcı bilgilerinde plaka bulunamadı');
            setUserPlaka(null);
            setLoading(false);
          }
        } else {
          console.error('Kullanıcı bilgileri alınamadı ve sessionStorage de uygun değil');
          navigate('/login');
        }
    } catch (error) {
      console.error('Kullanıcı bilgileri alınamadı:', error);
      navigate('/login');
    }
  };

  const fetchPlakaGecisleri = async (plaka: string, period: 'gunluk' | 'haftalik' | 'aylik') => {
    try {
      setLoading(true);
      console.log('Plaka geçişleri API çağrısı:', { plaka, period });
      
      const response = await fetch(API_ENDPOINTS.WEBSERVICE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ method: 'getPlakaGecisleri', plaka, period })
      });

      const responseData = await response.json();
      console.log('Plaka geçişleri API yanıtı:', responseData);

      if (responseData.success && responseData.data) {
        // API'den gelen veri yapısı: { success: true, data: { gecisler: [...], ozet: {...} } }
        const { gecisler = [], ozet = { giris_sayisi: 0, cikis_sayisi: 0, toplam_gecis: 0 } } = responseData.data;
        
        console.log('İşlenen geçişler:', gecisler);
        console.log('İşlenen özet:', ozet);
        
        setPlakaGecisleri(gecisler);
        setPlakaOzet(ozet);
      } else {
        console.error('Plaka geçişleri başarısız:', responseData.message);
        setPlakaGecisleri([]);
        setPlakaOzet({ giris_sayisi: 0, cikis_sayisi: 0, toplam_gecis: 0 });
      }
    } catch (error) {
      console.error('Plaka geçişleri hatası:', error);
      setPlakaGecisleri([]);
      setPlakaOzet({ giris_sayisi: 0, cikis_sayisi: 0, toplam_gecis: 0 });
    } finally {
      setLoading(false);
    }
  };

  const handlePeriodChange = async (newPeriod: 'gunluk' | 'haftalik' | 'aylik') => {
    setSelectedPeriod(newPeriod);
    if (userPlaka) {
      await fetchPlakaGecisleri(userPlaka, newPeriod);
    }
  };

  const formatPeriodText = (period: string): string => {
    switch(period) {
      case 'gunluk': return 'Günlük';
      case 'haftalik': return 'Haftalık';
      case 'aylik': return 'Aylık';
      default: return 'Aylık';
    }
  };

  if (loading) {
    return <TaxiLoader message="Plaka geçişleri yükleniyor..." />;
  }

  return (
    <div className="plaka-gecislerim-container">
      <Header title="Plaka Geçişlerim" />
      
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <div className="hero-icon">
            <FontAwesomeIcon icon={faExchangeAlt} />
          </div>
          <h1 className="hero-title">Plaka Geçişlerim</h1>
          <p className="hero-subtitle">
            {userPlaka ? `${userPlaka} - ${formatPeriodText(selectedPeriod)} Geçişler` : 'Plaka bilgisi bulunamadı'}
          </p>
        </div>
      </div>

      <div className="page-content">
        {userPlaka ? (
          <>
            {/* Period Seçim Butonları */}
            <div className="period-selector">
              <button 
                className={`period-btn ${selectedPeriod === 'gunluk' ? 'active' : ''}`}
                onClick={() => handlePeriodChange('gunluk')}
              >
                <FontAwesomeIcon icon={faCalendarAlt} />
                Günlük
              </button>
              <button 
                className={`period-btn ${selectedPeriod === 'haftalik' ? 'active' : ''}`}
                onClick={() => handlePeriodChange('haftalik')}
              >
                <FontAwesomeIcon icon={faCalendarAlt} />
                Haftalık
              </button>
              <button 
                className={`period-btn ${selectedPeriod === 'aylik' ? 'active' : ''}`}
                onClick={() => handlePeriodChange('aylik')}
              >
                <FontAwesomeIcon icon={faCalendarAlt} />
                Aylık
              </button>
            </div>

            {/* İstatistik Kartları */}
            <div className="stats-section">
              <div className="stats-grid">
                <div className="stat-card giris">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faCar} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-number">{plakaOzet.giris_sayisi}</div>
                    <div className="stat-label">Giriş</div>
                  </div>
                </div>
                <div className="stat-card cikis">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faExchangeAlt} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-number">{plakaOzet.cikis_sayisi}</div>
                    <div className="stat-label">Çıkış</div>
                  </div>
                </div>
                <div className="stat-card toplam">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-number">{plakaOzet.toplam_gecis}</div>
                    <div className="stat-label">Toplam</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Geçiş Listesi */}
            <div className="gecis-section">
              <div className="section-header">
                <h3>Geçiş Detayları</h3>
                <div className="section-badge">
                  {plakaGecisleri.length} kayıt
                </div>
              </div>
              
              {plakaGecisleri.length > 0 ? (
                <div className="gecis-list">
                  {plakaGecisleri.map((gecis, index) => (
                    <div key={index} className={`gecis-card ${gecis.tip.toLowerCase()}`}>
                      <div className="gecis-header">
                        <div className="gecis-tip">
                          <div className={`tip-badge ${gecis.tip.toLowerCase()}`}>
                            <FontAwesomeIcon 
                              icon={gecis.tip === 'GIRIS' ? faCar : faExchangeAlt} 
                            />
                            <span>{gecis.tip}</span>
                          </div>
                        </div>
                        <div className="gecis-tarih">
                          <div className="tarih">{new Date(gecis.Date).toLocaleDateString('tr-TR')}</div>
                          <div className="saat">{new Date(gecis.Date).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}</div>
                        </div>
                      </div>
                      <div className="gecis-body">
                        <div className="gecis-info">
                          <div className="info-item">
                            <span className="info-label">Plaka:</span>
                            <span className="info-value">{gecis.Plate}</span>
                          </div>
                          <div className="info-item">
                            <span className="info-label">Makine:</span>
                            <span className="info-value">{gecis.Machine}</span>
                          </div>
                          {gecis.Color && (
                            <div className="info-item">
                              <span className="info-label">Renk:</span>
                              <span className="info-value">{gecis.Color}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-state">
                  <div className="empty-icon">
                    <FontAwesomeIcon icon={faExchangeAlt} />
                  </div>
                  <h4>Geçiş Kaydı Bulunamadı</h4>
                  <p>Bu dönem için {userPlaka} plakasına ait geçiş kaydı bulunmamaktadır.</p>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">
              <FontAwesomeIcon icon={faCar} />
            </div>
            <h4>Plaka Bilgisi Bulunamadı</h4>
            <p>Plaka geçişlerini görüntülemek için plaka bilginiz sistemde kayıtlı olmalıdır. Lütfen sistem yöneticinizle görüşünüz.</p>
          </div>
        )}
      </div>

      <TabBar />
    </div>
  );
};

export default PlakaGecislerim; 